import React from "react";
import { Container, Card, CardBody, Button, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";

const SurveyClosed = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #eef2f7, #dfe9f3)",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col lg="7">
            <Card className="shadow-lg border-0" style={{ borderRadius: 22 }}>
              <CardBody
                className="p-5 d-flex flex-column justify-content-between"
                style={{ minHeight: 420 }}
              >
                <div className="text-center mb-4">
                  <div
                    style={{
                      width: 85,
                      height: 85,
                      borderRadius: "50%",
                      background: "#62CEB0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 20px",
                      boxShadow: "0 10px 25px rgba(255,95,109,0.4)",
                    }}
                  >
                    <i
                      className="bx bx-lock-alt"
                      style={{ fontSize: 38, color: "#fff" }}
                    />
                  </div>

                  <h2 className="fw-bold" style={{ color: "#ff5f6d" }}>
                    Survey Closed
                  </h2>
                </div>

                <div className="text-center px-4">
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: 16, lineHeight: 1.7 , fontWeight: 500}}
                  >
                    The submission deadline for this batch has already passed,
                    so new survey entries are no longer accepted.
                  </p>
                </div>

                <div className="text-center mt-4">
                  <Button
                    size="md"
                    className="px-4 py-3"
                    style={{
                      borderRadius: 20,
                      background: "#62CEB0",
                      border: "none",
                      boxShadow: "0 10px 25px rgba(102,126,234,0.45)",
                      transition: "0.3s",
                      fontSize: 12,
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.transform = "translateY(-2px)")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.transform = "translateY(0)")
                    }
                    onClick={() => navigate("/rater/login")}
                  >
                    Go Back to Login
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SurveyClosed;
